import {ChangeDetectionStrategy, Component, Input, OnInit, ViewChild} from "@angular/core";
import {Product, Scope, ScopeQuestion, StandardName} from "../../../../store/state/order.state";
import {NgOption, NgSelectComponent} from "@ng-select/ng-select";
import {FormGroup} from "@angular/forms";
import {NbPopoverDirective} from "@nebular/theme";
import {CompanyGeneralInfoFormService} from "../form-service/company-general-info.form.service";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {ConfigurationProvider} from "../../../../configuration/configuration.provider";

@Component({
    selector: 'company-scope',
    templateUrl: './company-scope.template.html',
    styleUrls: ['../company-general-info.style.scss', './company-scope.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CompanyScopeComponent implements OnInit {

	@Input() product: Product;
	@Input() allScopes: { [accBody: string] : Scope[] };
	@Input() form: FormGroup;
	@Input() isClientInput: boolean;
	@Input() clientCountry: string;

	@ViewChild('scopeSelector', {static: false}) ngSelect: NgSelectComponent;
	@ViewChild(NbPopoverDirective, {static: false}) popover: NbPopoverDirective;

	stringScopes: string[] = [];
	standard: StandardName;
	isIso27x01Product: boolean;
	iso27xScopeFixed$: Observable<boolean>;

	constructor(private formService: CompanyGeneralInfoFormService, private configProvider: ConfigurationProvider) {
	}

	ngOnInit(): void {
		this.standard = this.product.standard.name;
		this.isIso27x01Product = [StandardName.ISO_27001, StandardName.ISO_27001].includes(this.standard);
		this.stringScopes = this.allScopes[this.product.accreditationBody]
			.filter(sc => sc.standardName == this.product.standard.name)
			.map(sc => sc.code + ' - ' + sc.name);
		this.stringScopes.sort((a, b) => a.localeCompare(b));

		this.iso27xScopeFixed$ = this.configProvider.getConfigurationFor(this.clientCountry).pipe(
			map(config => config.clientCountryConfig?.order.iso27xScopeFixed && this.isIso27x01Product)
		);
	}

	getFormKey(): string {
		return this.standard;
	}

	searchScopesFn(searchString: string, scope: string): boolean {
		return scope.toLowerCase().includes(searchString.toLowerCase());
	}

	trackByScopesFcn(index: number, item: Scope) {
		return item.code;
	}

	selectScope(select: boolean, item: NgOption) {
		if (select) {
			this.ngSelect.select(item);
		} else {
			this.ngSelect.unselect(item);
		}
	}

	getScopeQuestions(selectedScope: Scope): ScopeQuestion[] {
		const scope = this.allScopes[this.product.accreditationBody].filter(sc => sc.code === selectedScope.code && sc.standardName === this.product.standard.name)[0];
		return scope == null ? null : scope.questions;
	}

	hasScopeQuestions(selectedScope: Scope): boolean {
		const scopeQuestions = this.getScopeQuestions(selectedScope);
		return scopeQuestions != null && scopeQuestions.length > 0;
	}

	getControlNameForScopeQuestion(selectedScope: Scope, index: number): string {
		return this.formService.getScopeQuestionControlNamePrefix(selectedScope, index) + this.product.standard.name;
	}

	shouldDisableRadio(controlName: string): boolean {
		const control = this.formService.getFormControl(this.product.standard.name, controlName);
		return control != null ? control.disabled : false;
	}

	fullControlName(controlPrefix: string) {
		return controlPrefix + this.standard;
	}

	isInvalid(controlPrefix: string) {
		return this.formService.isInvalid(this.standard, controlPrefix);
	}

	getValidationErrors(controlPrefix: string): Observable<string> {
		return this.formService.getErrorsString(this.getFormKey(), controlPrefix);
	}

	updateFormControl(controlPrefix: string, value: any) {
		this.formService.updateFormControl(controlPrefix, value, this.standard);
	}
}
